// export const ENDPOINT = "https://bankapp-spring.onrender.com/api/";
// export const ENDPOINT = "http://localhost:8080/api/";

// src/config/config.js
export const ENDPOINT = process.env.REACT_APP_API_URL;
